import { render, staticRenderFns } from "./orders-gallery.vue?vue&type=template&id=e2b66348&scoped=true"
import script from "./orders-gallery.vue?vue&type=script&lang=js"
export * from "./orders-gallery.vue?vue&type=script&lang=js"
import style0 from "./orders-gallery.vue?vue&type=style&index=0&id=e2b66348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b66348",
  null
  
)

export default component.exports